import { useTranslations } from "next-intl";

import type { RichTextBlok } from "@/bloks/RichText/RichText";
import RichText from "@/bloks/RichText/RichText";

import ProductAccordion from "../ProductAccordion";

const GarmentCare = (blok: RichTextBlok) => {
  const t = useTranslations();
  return (
    <ProductAccordion title={t("garmentCare")}>
      <RichText blok={blok} productPage={true} />
    </ProductAccordion>
  );
};

export default GarmentCare;
